import { memo } from 'react';
import classNames from 'classnames';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import styles from './TabBar.module.scss';
import TabBarItem from './TabBarItem';
import { ActiveItem, TabBarItem as TabBarItemType } from './constants';
import { isTabActive } from './utils/activeStateComparison';

type Props = {
  items: TabBarItemType[];
  active?: ActiveItem;
  onActiveChange: (item: TabBarItemType) => void;
  /** Suppress the trigger's own bottom-line highlight, e.g. when a shared sliding indicator already renders it */
  withoutStaticActiveLine?: boolean;
};

function TabBarMoreItems({
  items,
  active,
  onActiveChange,
  withoutStaticActiveLine,
}: Props) {
  const activeItem = items.find((item) => isTabActive(item.value, active));
  const activeItemTypeClass = activeItem?.type
    ? styles[activeItem.type]
    : undefined;
  const hasError = items.some((item) => item.hasError);

  return (
    <div
      data-id="more"
      // The cropped active item's `type` is mirrored onto the trigger so a
      // red/green/orange tab keeps its color while it lives in the dropdown —
      // and so the shared sliding indicator, which reads the same type, agrees
      // with the icon it sits under.
      className={classNames(styles.moreItem, styles.item, activeItemTypeClass, {
        [styles.active]: !!activeItem,
        [styles.hasError]: hasError,
        [styles.withoutStaticActiveLine]: withoutStaticActiveLine,
      })}
    >
      <MaterialIcon
        icon={`filter_${items.length > 9 ? '9+' : items.length}`}
        size="md-20"
      />
      <div className={styles.moreWrapper}>
        <div className={styles.moreContent}>
          {items.map((item) => (
            <TabBarItem
              isVisible
              key={item.value}
              item={item}
              active={active}
              onActiveChange={onActiveChange}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default memo(TabBarMoreItems);
